module.exports = __webpack_public_path__ + "static/img/dk.079b8347.svg";